// extracted by mini-css-extract-plugin
export var active = "_1w-d";
export var blink = "_1w-e";
export var container = "_1w-5";
export var controls = "_1w-0";
export var controlsRight = "_1w-1";
export var fakeCursor = "_1w-c";
export var hidden = "_1w-b";
export var quillContainerSmall = "_1w-7";
export var quillEditor = "_1w-6";
export var quillEditorSmall = "_1w-8";
export var quillFormatButtons = "_1w-a";
export var quillToolbar = "_1w-9";
export var removePadding = "_1w-2";
export var state = "_1w-3";
export var stateTitle = "_1w-4";